import { render, staticRenderFns } from "./advertisement-placement.vue?vue&type=template&id=7cd1429e&scoped=true"
import script from "./advertisement-placement.vue?vue&type=script&lang=js"
export * from "./advertisement-placement.vue?vue&type=script&lang=js"
import style0 from "./advertisement-placement.vue?vue&type=style&index=0&id=7cd1429e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd1429e",
  null
  
)

export default component.exports